import { AlertCircle } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type CrmTaskStatusBannerTone = "danger" | "warning" | "neutral";
type CrmTaskStatusBannerDensity = "default" | "compact";

interface CrmTaskStatusBannerProps {
  tone: CrmTaskStatusBannerTone;
  message: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  density?: CrmTaskStatusBannerDensity;
  className?: string;
}

export function CrmTaskStatusBanner({
  tone,
  message,
  actionLabel,
  onAction,
  density = "default",
  className,
}: CrmTaskStatusBannerProps) {
  return (
    <div
      className={cn(
        "rounded-md border",
        density === "compact" ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm",
        tone === "danger" && "border-[var(--color-destructive)]/20 bg-[var(--color-destructive)]/5 text-[var(--color-destructive)]",
        tone === "warning" && "border-[var(--color-warning)]/30 bg-[var(--color-warning)]/10 text-[var(--color-warning)]",
        tone === "neutral" && "border-[var(--color-border)] bg-[var(--color-surface)] text-[var(--color-muted-foreground)]",
        className,
      )}
    >
      {tone === "danger" && <AlertCircle className="mr-1 inline h-4 w-4" />}
      {message}
      {actionLabel && onAction && (
        <button type="button" onClick={onAction} className="ml-2 underline">
          {actionLabel}
        </button>
      )}
    </div>
  );
}
